<template>
    <div>
        <el-input-number
            v-if="mode == 'edit'"
            :min="min"
            :placeholder="placeholder" 
            :value="value" 
            @change="update"
            :controls="controls">
        </el-input-number>
        <p v-else>
            {{value}}
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            mode: {
                type: String
            },
            min: {
                type: Number,
                required: false,
                default: 0
            },
            controls: {
                type: Boolean,
                required: false,
                default: false
            },
            value: {
                type: Number,
                required: false,
                default: 0
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            }
        },
        data(){
            return {
            }
        },
        methods: {
            update(newVal){
                this.$emit('input', newVal)
            }
        }
    }
</script>
